/* Future Form - shop page (Wellness Systems).
   Light / Heat / Cold filter: every product card is tagged with the
   technologies in its own title (a sauna pod with red light counts as both
   heat and light), falling back to its category. Choosing a technology shows
   only matching systems, hides empty categories, updates the counts and
   locks the background light to that colour. Also builds the sticky bar
   (filter plus category names) and lets cards rise in as they arrive. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HUE = { light: 0, heat: 1, cold: 2 };
  var LABEL = { all: 'All', light: 'Light', heat: 'Heat', cold: 'Cold' };

  function techOf(text) {
    var t = (text || '').toLowerCase(), s = {};
    if (/\bcryo|\bcold\b|\bice\b|freez|nitrogen/.test(t)) s.cold = 1;
    if (/sauna|\bheat\b|far[- ]infrared|\bsteam\b|\bpods?\b/.test(t) && !/\bpanel/.test(t)) s.heat = 1;
    if (/red light|red & near|near[- ]infrared|\bled\b|photobiomod|light therapy|light system|\bpanels?\b|\bmasks?\b|\bhelmet|\bbeds?\b/.test(t)) s.light = 1;
    return s;
  }
  function toneOf(s) { return s.cold ? 'cold' : s.heat ? 'heat' : s.light ? 'light' : 'neutral'; }
  function plural(n) { return n + (n === 1 ? ' system' : ' systems'); }
  function keys(o) { return Object.keys(o); }

  function init() {
    var hero = document.querySelector('.ffx-shop');
    if (!hero || hero.dataset.ffxShop) return;
    hero.dataset.ffxShop = '1';
    var header = document.querySelector('[data-ff-header]');
    var techBtns = hero.querySelectorAll('[data-tech]');
    var items = [];
    var uniq = { all: {}, light: {}, heat: {}, cold: {} };

    /* 1. read categories and tag every card */
    document.querySelectorAll('#MainContent > .shopify-section').forEach(function (s) {
      if (s.contains(hero)) return;
      var h = s.querySelector('.ff-head h2') || s.querySelector('h2');
      var cards = Array.prototype.slice.call(s.querySelectorAll('.ff-card'));
      if (!h || !cards.length) return;
      var title = (h.getAttribute('aria-label') || h.textContent).replace(/\s+/g, ' ').trim();
      var secTech = techOf(title);
      var tone = toneOf(secTech);
      var sec = s.querySelector(':scope > section') || s;
      sec.classList.add('ffx-cat', 'ffx-tone--' + tone);
      var count = s.querySelector('.ffx-count');
      if (!count) {
        count = document.createElement('span');
        count.className = 'ffx-count';
        h.insertAdjacentElement('afterend', count);
      }
      count.textContent = plural(cards.length);
      cards.forEach(function (card) {
        var t = card.querySelector('.ff-card__t');
        var tech = techOf(t ? t.textContent : '');
        if (!keys(tech).length) tech = secTech;
        card._tech = tech;
        var a = card.querySelector('a[href*="/products/"]') || card.closest('a');
        var id = a ? a.getAttribute('href').split('?')[0] : (t ? t.textContent : Math.random());
        uniq.all[id] = 1;
        keys(tech).forEach(function (k) { uniq[k][id] = 1; });
      });
      items.push({ id: s.id, title: title, tone: tone, el: s, cards: cards, count: count });
    });
    if (!items.length) return;

    /* counts on the technology cards */
    techBtns.forEach(function (b) {
      var n = b.querySelector('[data-n]');
      if (n) n.textContent = plural(keys(uniq[b.getAttribute('data-tech')] || {}).length);
    });
    hero.classList.add('is-ready');

    /* 2. sticky bar: filter + category names */
    var bar = document.createElement('nav');
    bar.className = 'ffx-catbar';
    bar.setAttribute('aria-label', 'Filter and categories');
    var inner = document.createElement('div');
    inner.className = 'ffx-catbar__in';
    var seg = document.createElement('div');
    seg.className = 'ffx-seg';
    seg.setAttribute('role', 'group');
    seg.setAttribute('aria-label', 'Filter by technology');
    var segBtns = [];
    ['all', 'light', 'heat', 'cold'].forEach(function (k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ffx-seg__b ffx-tone--' + (k === 'all' ? 'neutral' : k);
      b.setAttribute('data-tech', k);
      b.setAttribute('aria-pressed', k === 'all' ? 'true' : 'false');
      if (k !== 'all') { var d = document.createElement('i'); d.setAttribute('aria-hidden', 'true'); b.appendChild(d); }
      b.appendChild(document.createTextNode(LABEL[k]));
      seg.appendChild(b);
      segBtns.push(b);
    });
    var sep = document.createElement('span');
    sep.className = 'ffx-catbar__sep';
    sep.setAttribute('aria-hidden', 'true');
    var cats = document.createElement('div');
    cats.className = 'ffx-catbar__cats';
    items.forEach(function (it) {
      var a = document.createElement('a');
      a.href = '#' + it.id;
      a.className = 'ffx-chip ffx-tone--' + it.tone;
      var dot = document.createElement('i');
      dot.setAttribute('aria-hidden', 'true');
      a.appendChild(dot);
      a.appendChild(document.createTextNode(it.title));
      cats.appendChild(a);
      it.chip = a;
    });
    inner.appendChild(seg); inner.appendChild(sep); inner.appendChild(cats);
    bar.appendChild(inner);
    document.body.appendChild(bar);

    function hdrBottom() { return header ? Math.max(0, header.getBoundingClientRect().bottom) : 0; }
    function scrollToEl(el) {
      var top = el.getBoundingClientRect().top + window.pageYOffset - (bar.offsetHeight + 70);
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    }

    /* 3. the filter */
    var current = 'all';
    function apply(k, fromUser) {
      current = k;
      [].forEach.call(techBtns, function (b) {
        var on = b.getAttribute('data-tech') === k;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      segBtns.forEach(function (b) {
        var on = b.getAttribute('data-tech') === k;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      hero.classList.toggle('is-filtered', k !== 'all');
      if (k === 'all') hero.removeAttribute('data-ffx-lock');
      else hero.setAttribute('data-ffx-lock', String(HUE[k]));

      var first = null;
      items.forEach(function (it) {
        var n = 0, j = 0;
        it.cards.forEach(function (card) {
          var show = k === 'all' || !!card._tech[k];
          var was = !card.classList.contains('ffx-out');
          card.classList.toggle('ffx-out', !show);
          if (show) {
            n++;
            if (fromUser && !reduce && card.classList.contains('is-up')) {
              card.classList.remove('ffx-pop');
              void card.offsetWidth;
              card.style.setProperty('--j', Math.min(j++, 8));
              card.classList.add('ffx-pop');
            }
          }
          void was;
        });
        it.el.classList.toggle('ffx-gone', n === 0);
        it.chip.hidden = n === 0;
        it.count.textContent = plural(n);
        if (n && !first) first = it.el;
      });

      try {
        var url = new URL(window.location.href);
        if (k === 'all') url.searchParams.delete('tech'); else url.searchParams.set('tech', k);
        window.history.replaceState(null, '', url.toString());
      } catch (e) {}

      if (fromUser && first) {
        var r = first.getBoundingClientRect();
        if (r.top > window.innerHeight * 0.75 || r.top < 0) scrollToEl(first);
      }
      request();
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-tech]');
      if (b && (hero.contains(b) || bar.contains(b))) {
        var k = b.getAttribute('data-tech');
        apply(k === current && k !== 'all' ? 'all' : k, true);
        return;
      }
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || !bar.contains(a)) return;
      var el = document.getElementById(a.getAttribute('href').slice(1));
      if (!el) return;
      e.preventDefault();
      scrollToEl(el);
    });
    document.addEventListener('animationend', function (e) {
      if (e.target.classList && e.target.classList.contains('ffx-pop')) e.target.classList.remove('ffx-pop');
    });

    /* 4. sticky bar position and the category you are in */
    var cur = -2, ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      bar.classList.toggle('is-on', hero.getBoundingClientRect().bottom < 40);
      bar.style.top = hdrBottom() + 'px';
      var mark = hdrBottom() + bar.offsetHeight + vh * 0.3;
      var idx = -1;
      items.forEach(function (it, i) {
        if (it.el.classList.contains('ffx-gone')) return;
        if (it.el.getBoundingClientRect().top <= mark) idx = i;
      });
      if (idx !== cur) {
        cur = idx;
        items.forEach(function (it, i) {
          var on = i === idx;
          it.chip.classList.toggle('is-on', on);
          if (on) {
            it.chip.setAttribute('aria-current', 'true');
            var left = it.chip.offsetLeft - (cats.clientWidth - it.chip.offsetWidth) / 2;
            cats.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
          } else {
            it.chip.removeAttribute('aria-current');
          }
        });
      }
    }
    function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    if (header) header.addEventListener('transitionend', request);

    var start = 'all';
    try { start = new URL(window.location.href).searchParams.get('tech') || 'all'; } catch (e) {}
    apply(LABEL[start] ? start : 'all', false);

    /* 5. cards rise in as each category arrives */
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-up');
        io.unobserve(e.target);
      });
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (it) {
      it.cards.forEach(function (card, i) {
        card.classList.add('ffx-rise');
        card.style.setProperty('--i', i % 4);
        io.observe(card);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
